export default __webpack_public_path__ + "media/images/backgrounds/bg-04-1918x660-1474fa6756e38bf1cc29094ca600ed26.jpg";